export default __webpack_public_path__ + "static/post1-3c799d4aa17c1bb3dfa9fdfe8f0708e8.jpg";